__turbopack_context__.v({
  "personal-details-inputs-container": "EmailSignatureEditorPersonalSection-module-scss-module__hj91ZG__personal-details-inputs-container",
  "personal-details-names-input": "EmailSignatureEditorPersonalSection-module-scss-module__hj91ZG__personal-details-names-input",
  "personal-details-names-inputs-container": "EmailSignatureEditorPersonalSection-module-scss-module__hj91ZG__personal-details-names-inputs-container",
});
